import React from 'react';
import { Layout } from 'antd';
import Users from '../modules/Users';

const { Content } = Layout;

const UsersRoute = ({match}) => {
    return <Content
        style={{
            // margin: '24px 16px',
            padding: 24,
            background: '#fff',
            minHeight: 280,
        }}
    >
        <Users />
    </Content>
}

export default UsersRoute;